import {
  SAVE_DATA_BOOKING_REQUEST,
  SAVE_DATA_BOOKING_SUCCESS,
  RESET_BOOKING_CONFIRM
} from "./constants";

import { IBookingConfirm, IAction } from "./../../../models";

const initialState: IBookingConfirm = {
  bookingNumber: '',
  error: false
};

export function reducer(
  state = initialState,
  { type, payload }: IAction
): IBookingConfirm {
  switch (type) {
    case SAVE_DATA_BOOKING_REQUEST: 
      return {
        ...state
      };
    case SAVE_DATA_BOOKING_SUCCESS:
      return {
        ...state,
        ...payload
      };
    case RESET_BOOKING_CONFIRM:
      return {
        bookingNumber: '',
        error: false
      }
    default:
      return state;
  }
}
